module.exports = __webpack_public_path__ + "static/img/collect-icon1.2885f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trademark/v230701/collect-icon1.png
// module id = pF3G
// module chunks = 0